import { call, put } from 'redux-saga/effects';

import { error } from '@pressreader/logger';
import { openAlertOk } from '@pressreader/popups-alert';
import { localizedString } from '@pressreader/resources';
import { legacyAppLoadBegan, legacyAppLoadDone, legacyAppLoadFailed } from '@pressreader/views-common';

let legacyModule: any = null;

async function loadViewerLegacyModule(canRetry = true) {
    try {
        const importTask = import(/* webpackChunkName: "viewer.legacy" */ 'init.web');
        const m = await importTask;
        await m.runInit();

        return m;
    } catch (err) {
        error(err);
        if (canRetry) {
            return loadViewerLegacyModule(false);
        } else {
            throw err;
        }
    }
}

async function loadLegacyAuthentication() {
    const { default: authentication } = await import(/* webpackChunkName: "viewer.legacy" */ 'authentication/nd.authentication');
    return authentication;
}

async function loadLegacyCatalog() {
    const { default: uiCatalog } = await import(/* webpackChunkName: "viewer.legacy" */ 'nd.ui.catalog');
    return uiCatalog;
}

function* loadLegacyApp(): GeneratorResult<boolean> {
    if (legacyModule) {
        return true;
    }

    yield put(legacyAppLoadBegan());

    try {
        legacyModule = yield call(loadViewerLegacyModule);
        yield put(legacyAppLoadDone());

        return true;
    } catch (err) {
        yield put(legacyAppLoadFailed());

        yield openAlertOk({ message: localizedString('App.LegacyApp.Load.Error') });
    }

    return false;
}

export { loadLegacyApp, loadLegacyAuthentication, loadLegacyCatalog };
